module.exports = __webpack_public_path__ + "static/img/RWD1266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWD1266_1.png
// module id = RjZM
// module chunks = 0